var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MinimalPresentationsList',{on:{"logout":_vm.onLogout,"selectPresentation":_vm.onSelectPresentation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }